import ActivityTimeline from 'components/activity/ActivityTimeline';
import { taskTypeLabel } from 'constants/taskTypes';
import useCrmContext from 'hooks/useCrmContext';
import useText from 'hooks/useText';
import { useEffect, useState } from 'react';
import crmApi from 'server/crm/crmApi';
import taskActivityItems from './taskActivityItems';
import { TaskActivitySkeleton } from './TaskPanelSkeletons';

// The « Activité » tab of a task: its history, reloaded when the task changes.
const TaskActivityTab = ({ task, team, contacts }) => {
  const { language, text } = useText('taskActivity');
  const { call, me } = useCrmContext();
  const [events, setEvents] = useState(null);
  const signature = `${task.id}|${task.doneAt}|${task.title}|${task.assigneeId}|${task.dueOn}|${task.note}`;

  useEffect(() => {
    let alive = true;
    call(crmApi.getTaskActivity, { taskId: task.id }).then(
      (list) => alive && setEvents(list),
      () => alive && setEvents([]),
    );
    return () => {
      alive = false;
    };
  }, [call, task.id, signature]);

  if (!events) return <TaskActivitySkeleton />;
  return (
    <ActivityTimeline
      items={taskActivityItems(events, {
        text,
        typeLabel: (type) => taskTypeLabel(language, type),
        team,
        companies: contacts,
        creator: task.createdByPerson,
        meId: me?.id,
      })}
    />
  );
};

export default TaskActivityTab;
